import React from 'react';
import Component from 'components/component';
import BrandingPositionInput from './branding-position-input';
import { Modal } from 'components/modal';

const logobugs = {
    left_top: require(`assets/logobugs/255px_logo_bug_tl.png`),
    center_top: require(`assets/logobugs/255px_logo_bug_tm.png`),
    right_top: require(`assets/logobugs/255px_logo_bug_tr.png`),
    left_bottom: require(`assets/logobugs/255px_logo_bug_bl.png`),
    center_bottom: require(`assets/logobugs/255px_logo_bug_bm.png`),
    right_bottom: require(`assets/logobugs/255px_logo_bug_br.png`),
    we_left_top: require(`assets/logobugs/we-left-top.png`),
    we_right_top: require(`assets/logobugs/we-right-top.png`),
    we_left_bottom: require(`assets/logobugs/we-left-bottom.png`),
    we_right_bottom: require(`assets/logobugs/we-right-bottom.png`),
    credit_left_top: require(`assets/logobugs/we-left-top.png`),
    credit_right_top: require(`assets/logobugs/we-right-top.png`),
    credit_left_bottom: require(`assets/logobugs/we-left-bottom.png`),
    credit_right_bottom: require(`assets/logobugs/we-right-bottom.png`),
    credit_center_bottom: require(`assets/logobugs/we-center-bottom.png`),
    credit_center_top: require(`assets/logobugs/we-center-top.png`),
};

export default class BrandingPosition extends Component {

    static defaultProps = {
        image: require("./example.jpg"),
        position: 'left_top',
        onClose(){},
        worldExclusive: false,
        exclusive: false,
    }

    state = {
        position: this.props.position
    }

    onChange = (ev) => {
        this.setState({
            position: ev.target.value
        })
    }

    save = (ev) => {
        if(this.props.save) {
            this.props.save(this.state.position);
        }

        this.props.onClose()
    }

    render() {
        return (
            <Modal onClose={this.save}>
                <div className="popup-bp">
                    <div className="branding-positions">
                        <div className="branding-positions-img">
                            <img
                                src={logobugs[(this.props.worldExclusive ? 'we_' : this.props.exclusive ? 'credit_': '') + this.state.position]}
                                className="branding-position__img"
                                style={{
                                    backgroundImage: `url(${
                                        this.props.image
                                        })`,
                                    backgroundSize: 'cover',
                                    backgroundColor: '#f2f2f2',
                                    width: '100%'
                                }}
                                alt=""
                            />
                        </div>
                        <div className="branding-positions-subtitle">
                            Branding position
                        </div>
                        <BrandingPositionInput
                            onChange={this.onChange}
                            name="position"
                            value={this.state.position}
                            worldExclusive={this.props.worldExclusive}
                        />
                        {this.props.save && (
                            <div className="branding-positions-button">
                                <button type="button" className="button button--small-green" onClick={this.save}>Save position</button>
                            </div>
                        )}
                    </div>
                </div>
            </Modal>
        );
    }
}

